export default "__VITE_ASSET__D17Ha6MZ__"